import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { useLang } from "@/context/LangContext";
import { LANGUAGES, t } from "@/i18n";

export const LanguageSelect = () => {
  const { lang, setLang } = useLang();
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger data-testid="language-select" aria-label={t("Lingua")}
        className="nv-press h-14 w-auto min-w-[64px] sm:min-w-[170px] gap-2 rounded-xl bg-[#161e2e] border border-[#243047] text-base font-semibold">
        <Globe className="h-6 w-6 text-[#4accff] shrink-0" />
        <div className="sm:hidden uppercase">{lang}</div>
        <div className="hidden sm:block">{LANGUAGES.find(([c]) => c === lang)?.[1]}</div>
      </SelectTrigger>
      <SelectContent className="z-[1000] max-h-[60vh]" data-testid="language-options">
        {LANGUAGES.map(([code, name]) => (
          <SelectItem key={code} value={code} className="py-3 text-base" data-testid={`language-option-${code}`}>
            {name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
